import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pageView } from '../analytics'
import { analyticsPath } from '../pages/mcpAuthorize/mcpAuthorizeModel'

/**
 * Sends a GA4 page_view on every client-side navigation (SPA).
 */
export default function AnalyticsRouteListener() {
  const location = useLocation()

  useEffect(() => {
    // /mcp-authorize's query carries the AI platform's authorization handle; analytics records the path only.
    pageView(analyticsPath(location.pathname, location.search))
  }, [location.pathname, location.search])

  return null
}
